export default "__VITE_ASSET__DncocNg7__"